<template>
  <div v-if="pageType === 'overview'">
    <a-tabs
      :activeKey="tabKey"
      @change="onTabChange"
      :animated="false"
      style="background-color: #fff"
    >
      <a-tab-pane v-for="item in tabList" :key="item.key">
        <span slot="tab">
          <!-- <a-icon type="apple" /> -->
          <div style="display: flex; align-items: center; justify-content: center">
            <img
              :src="require(`@assets/schoolChangeTrend/${renderCardInfo(item.key).icon}.png`)"
              alt="图标"
            />
            <span style="font-size: 16px; margin-left: 6px">
              {{ renderCardInfo(item.key).title }}
            </span>
          </div>
        </span>
        <component
          :is="renderCardInfo(item.key).component"
          @cardDetail="onTabChange"
          @skipUnhappyStu="skipUnhappyStu"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
  <div v-else-if="pageType === 'unhappyStudent'">
    <a-card class="card-container">
      <TableList
        :columns="unHappyStudentTable.columns"
        :tableData="unHappyStudentTable.tableData"
        :loading="unHappyStudentTable.loading"
        :scroll="false"
        :pagination="unHappyStudentTable.pagination"
        @change="handleTableChange"
      >
        <div slot="queryArea" style="margin-bottom: 20px">
          <div style="margin-bottom: 20px; font-size: 16px; font-weight: bold; cursor: pointer">
            <span @click.stop="togglePage('overview')">校园概览</span>
            <a-icon type="right" style="margin: 0 6px" />
            <span>不开心学生</span>
          </div>
          <div>
            <j-dict-select-tag
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              allowClear
              style="width: 170px"
            />
            <j-dict-select-tag
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="
                'school_class,name,id,grade_id=\'' +
                (!queryParam.gradeId ? '-11' : queryParam.gradeId) +
                '\''
              "
              :async="true"
              style="width: 170px; margin: 0 10px"
            />
            <a-button type="primary" @click="getUnhappyStudentList">查询</a-button>
          </div>
        </div>
        <template slot="action" slot-scope="{ record }">
          <span class="action-detail" @click="viewModal(record, 2)">查看详情</span>
        </template>
      </TableList>
    </a-card>
    <ViewKeyPointModal ref="viewKeyPointModal" />
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import CampusOverview from './components/campusPreview/CampusOverview'
import CampusMood from './components/campusPreview/CampusMood'
import CampusDynamic from './components/campusPreview/CampusDynamic'
import CounselingRecord from './components/campusPreview/CounselingRecord'
import DynamicPublishing from './components/campusPreview/DynamicPublishing/index'
import PsychologyReservation from './components/campusPreview/PsychologyReservation'
import ViewKeyPointModal from './components/ViewKeyPointModal'
import { getAction } from '@/api/manage'
import moment from 'moment'
import { openNewTabPage } from '@/utils/util'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'SchoolChangeTrend',
  components: {
    TableList,
    CampusOverview,
    CampusMood,
    CampusDynamic,
    ViewKeyPointModal,
    CounselingRecord,
    DynamicPublishing,
    PsychologyReservation,
  },
  data() {
    return {
      pageType: 'overview',
      queryParam: {},
      tabKey: 'overview',
      tabList: [
        {
          key: 'overview',
          scopedSlots: { tab: 'customRender' },
        },
        {
          key: 'mood',
          scopedSlots: { tab: 'customRender' },
        },
        {
          key: 'dynamic',
          scopedSlots: { tab: 'customRender' },
        },
        // {
        //   key: 'counselingRecord',
        //   scopedSlots: { tab: 'customRender' },
        // },
        // {
        //   key: 'psychologyReservation',
        //   scopedSlots: { tab: 'customRender' },
        // },
        // {
        //   key: 'dynamicPublishing',
        //   scopedSlots: { tab: 'customRender' },
        // },
      ],
      unHappyStudentTable: {
        columns: [
          {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
          },
          {
            title: '年级',
            dataIndex: 'grade',
            align: 'center',
          },
          {
            title: '班级',
            dataIndex: 'class',
            align: 'center',
          },
          {
            title: '姓名',
            dataIndex: 'student_name',
            align: 'center',
          },
          {
            title: '时间',
            dataIndex: 'date',
            align: 'center',
            customRender: (text) => {
              return moment(text).format('YYYY-MM-DD')
            },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
        loading: false,
        pagination: tablePagination,
      },
    }
  },
  created() {
    // 获取路由信息
    console.log('路由信息--', this.$router.history.current.query)
    const query = this.$router.history.current.query
    if (query?.tab) {
      this.tabKey = query.tab
    }
  },
  methods: {
    renderCardInfo(key) {
      switch (key) {
        case 'overview':
          return {
            icon: 'overview',
            title: '校园概览',
            component: 'CampusOverview',
          }
        case 'mood':
          return {
            icon: 'mood',
            title: '校园心情',
            component: 'CampusMood',
          }
        case 'dynamic':
          return {
            icon: 'dynamic',
            title: '今日校园动态',
            component: 'CampusDynamic',
          }
        case 'counselingRecord':
          return {
            icon: 'counselingRecord',
            title: '辅导记录',
            component: 'CounselingRecord',
          }
        case 'psychologyReservation':
          return {
            icon: 'psychologyReservation',
            title: '心理预约',
            component: 'PsychologyReservation',
          }
        case 'dynamicPublishing':
          return {
            icon: 'dynamicPublishing',
            title: '动态发布',
            component: 'DynamicPublishing',
          }
      }
    },
    async onTabChange(key) {
      this.tabKey = key
    },
    // 分页变化
    handleTableChange(page) {
      this.$set(this.unHappyStudentTable, 'pagination', page)
      this.getUnhappyStudentList()
    },
    togglePage(type) {
      this.pageType = type
    },
    // 查看详情
    viewModal(record, type) {
      // console.log('查看--', record)
      // const studentInfo = { id: record.student_id, name: record.student_name }
      // this.$refs.viewKeyPointModal.show(studentInfo, type)
      openNewTabPage({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId || record.student_id,
          pagePath: '/school/statistic/SchoolChangeTrend',
        },
      })
    },
    skipUnhappyStu(record) {
      this.pageType = 'unhappyStudent'
      this.getUnhappyStudentList(record)
    },
    // 查询
    getUnhappyStudentList(record) {
      this.$set(this.unHappyStudentTable, 'loading', true)
      let params = {}
      if (this.queryParam.gradeId && this.queryParam.classId) {
        params = {
          gradeId: this.queryParam.gradeId,
          classId: this.queryParam.classId,
        }
      } else if (this.queryParam.gradeId) {
        params = {
          gradeId: this.queryParam.gradeId,
        }
      } else if (record) {
        params = { gradeId: record.grade_id }
      }
      params = {
        ...params,
        pageNo: this.unHappyStudentTable.pagination.current,
        pageSize: this.unHappyStudentTable.pagination.pageSize,
      }
      getAction('/statistic/lowStudent', params)
        .then((res) => {
          console.log('res--', res)
          if (res.success) {
            const tableData =
              res.result.records.length > 0
                ? res.result.records.map((item, index) => ({
                    ...item,
                    index: index + 1,
                  }))
                : []
            this.$set(this.unHappyStudentTable, 'tableData', tableData)
            this.$set(this.unHappyStudentTable.pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.unHappyStudentTable, 'loading', false)
          this.queryParam = {}
        })
    },
  },
}
</script>
<style lang="less" scoped>
.card-container {
  width: 100%;
  min-height: 80vh;
}

.breadcrumb {
  margin-bottom: 20px;
  font-size: 16px;
  cursor: pointer;
}

.action-detail {
  color: #0077fa !important;
  cursor: pointer !important;
}
</style>
